module.exports = __webpack_public_path__ + "media/advertise_with_us/cover-bg-9af424cf.jpg";